import React from 'react';
import { map } from 'lodash';
import { PERCENTAGE_ABSOLUTE_TABS_VALUE } from '../../../../utils/constants.js';
import { DateUtil } from '../../../../utils/date-util.js';
import {
   IMPACTED_FARES_COUNT_KEY,
   RECOMMENDATION_STATUS_KEYS,
   UNIQUE_COUNT_KEY,
} from '../charts-util.js';

const getTacticalConfigColumns = (
   recommendationStatus,
   reasonsDropdownData
) => {
   const columnsConfig = [
      {
         key: 'region',
         label: 'region',
         Header: 'Region',
         accessor: 'region',
         thClassName: 'text-align-center',
         tdClassName: 'cell-market-region',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: 'pos',
         label: 'POS',
         Header: 'POS',
         accessor: 'pos',
         thClassName: 'text-align-center',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: 'origin',
         label: 'Origin',
         Header: 'Origin',
         accessor: 'origin',
         thClassName: 'text-align-center',
         tdClassName: 'cell-market-region',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: 'destination',
         label: 'destination',
         Header: 'Destination',
         accessor: 'destination',
         thClassName: 'text-align-center',
         tdClassName: 'cell-market-region',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: UNIQUE_COUNT_KEY,
         label: 'Unique',
         Header: 'Unique',
         accessor: UNIQUE_COUNT_KEY,
         thClassName: 'text-align-center',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: IMPACTED_FARES_COUNT_KEY,
         label: 'Impacted Fares',
         Header: 'Impacted Fares',
         accessor: IMPACTED_FARES_COUNT_KEY,
         thClassName: 'text-align-center',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
   ];

   map(reasonsDropdownData, (eachGroup) => {
      if (
         recommendationStatus === RECOMMENDATION_STATUS_KEYS.RECOMMENDATION ||
         recommendationStatus === RECOMMENDATION_STATUS_KEYS.NO_RECOMMENDATION
      ) {
         map(eachGroup.children, (eachReason) => {
            if (eachReason.checked) {
               columnsConfig.push({
                  key: eachReason.label,
                  label: eachReason.label,
                  Header: eachReason.label,
                  accessor: eachReason.label,
                  thClassName: 'text-align-center',
                  tdClassName: 'text-align-center',
                  tooltip: {
                     isShowTooltip: true,
                     isShowRowValues: true,
                  },
               });
            }
         });
      } else if (
         recommendationStatus === RECOMMENDATION_STATUS_KEYS.AUTO_APPROVAL_STOP
      ) {
         if (eachGroup.checked) {
            columnsConfig.push({
               key: eachGroup.label,
               label: eachGroup.label,
               Header: eachGroup.label,
               accessor: eachGroup.label,
               thClassName: 'text-align-center',
               tdClassName: 'text-align-center',
               tooltip: {
                  isShowTooltip: true,
                  isShowRowValues: true,
               },
            });
         }
      }
   });

   return columnsConfig;
};

const getTacticalConfigColumnsForApprovalStatusDashboard = (
   datesInSequence,
   percentAbsolute,
   posOnClickHandler
) => {
   const columnsConfig = [
      {
         key: 'analyst',
         label: 'Analyst',
         Header: 'Analyst',
         accessor: 'analyst',
         thClassName: 'column-style column-style-width-6rem',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: 'status',
         label: 'Approval Status',
         Header: 'Approval Status',
         accessor: 'status',
         thClassName: 'column-style column-style-width-10rem',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      },
      {
         key: 'pos',
         label: 'POS',
         Header: 'POS',
         accessor: 'pos',
         thClassName: 'column-style column-style-width-4rem',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
         Cell: ({ cell: { value, row } }) =>
            row &&
            row.original &&
            row.original.analyst_status === 'No Recommendation' ? (
               <a
                  className='spark-link spark-bold'
                  href
                  onClick={() => posOnClickHandler(value)}
               >
                  {value}
               </a>
            ) : (
               <span>{value}</span>
            ),
      },
   ];

   map(datesInSequence, (eachDate, key) => {
      columnsConfig.push({
         key: DateUtil.formatDate(
            key,
            DateUtil.DATE_FORMATS.DAY_HYPHEN_MONTH_NAME
         ),
         label:
            DateUtil.formatDate(
               key,
               DateUtil.DATE_FORMATS.DAY_HYPHEN_MONTH_NAME
            ) +
            (PERCENTAGE_ABSOLUTE_TABS_VALUE.PERCENTAGE === percentAbsolute
               ? ' %'
               : ''),
         Header:
            DateUtil.formatDate(
               key,
               DateUtil.DATE_FORMATS.DAY_HYPHEN_MONTH_NAME
            ) +
            (PERCENTAGE_ABSOLUTE_TABS_VALUE.PERCENTAGE === percentAbsolute
               ? ' %'
               : ''),
         accessor: DateUtil.formatDate(
            key,
            DateUtil.DATE_FORMATS.DAY_HYPHEN_MONTH_NAME
         ),
         thClassName: 'text-align-center',
         tdClassName: 'text-align-center',
         tooltip: {
            isShowTooltip: true,
            isShowRowValues: true,
         },
      });
   });

   return columnsConfig;
};

export const getTacticalConfigColumnsForRecommStatus = (
   recommendationStatus,
   reasonsDropdownData,
   datesInSequence,
   percentAbsolute,
   posOnClickHandler
) => {
   let columnsConfig = [];
   switch (recommendationStatus) {
      case RECOMMENDATION_STATUS_KEYS.RECOMMENDATION:
      case RECOMMENDATION_STATUS_KEYS.NO_RECOMMENDATION:
      case RECOMMENDATION_STATUS_KEYS.AUTO_APPROVAL_STOP:
         columnsConfig = getTacticalConfigColumns(
            recommendationStatus,
            reasonsDropdownData
         );
         break;
      case RECOMMENDATION_STATUS_KEYS.APPROVAL_STATUS:
         columnsConfig = getTacticalConfigColumnsForApprovalStatusDashboard(
            datesInSequence,
            percentAbsolute,
            posOnClickHandler
         );
         break;
      default:
         columnsConfig = [];
   }
   return columnsConfig;
};
